/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const baseCabinet4DrawerComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('BaseCabinet4Drawer').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/higgins.glb',
            objectName: 'B4D24',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=base-cabinet-4-drawer.js.map